import { render, staticRenderFns } from "./StockQuotes.vue?vue&type=template&id=76ca327e&scoped=true&"
import script from "./StockQuotes.vue?vue&type=script&lang=js&"
export * from "./StockQuotes.vue?vue&type=script&lang=js&"
import style0 from "./StockQuotes.vue?vue&type=style&index=0&id=76ca327e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca327e",
  null
  
)

export default component.exports